<template>
  <breeze-landing-layout>
    <div class="custom-welcome-landing"></div>
    <div class="custom-welcome-background" ref="landing">
      <div class="form-floating mb-4 text-center">
        <img src="/media/live/logo.png" alt="Corsync" class="logo" />
      </div>
      <div class="custom-welcome">
        <div class="row">
          <div class="col-12 custom-intro">
            We've worked with hundreds of organizations and tens of thousands of
            individuals providing results based wellness solutions. We combine
            the right science and technology to deliver world class outcomes for
            your clients and employees.
          </div>
        </div>
        <div class="row" v-if="$page.props.auth.user">
          <div class="col-12 text-center">
            <inertia-link href="/dashboard" class="btn btn-link">
              Dashboard
            </inertia-link>
          </div>
        </div>
        <div class="row mt-5" v-else>
          <div class="col-12 text-center" v-if="canLogin">
            <inertia-link href="/login" class="btn btn-link">
              Login
            </inertia-link>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-footer">
      <div class="row">
        <div class="col-10">
          COPYRIGHT © Nuvita CorSync •
          <a href="https://www.nuvita.com/nuvita/fine-print/" target="_blank"
            >Fine Print</a
          >
        </div>
        <div class="col-2 custom-version">
          Laravel v{{ laravelVersion }} (PHP v{{ phpVersion }})
        </div>
      </div>
    </div>
  </breeze-landing-layout>
</template>
<script>
import BreezeLandingLayout from '@/Layouts/Landing'
export default {
  name: 'welcome',
  components: {
    BreezeLandingLayout,
  },
  props: {
    canLogin: Boolean,
    canRegister: Boolean,
    canResetPassword: Boolean,
    laravelVersion: String,
    phpVersion: String,
  },
  data() {
    return {
      windowHeight: window.innerHeight,
    }
  },
  mounted() {
    if (this.$refs.landing) {
      this.$refs.landing.style.height = `${this.windowHeight}px`
    }
  },
}
</script>
<style lang="scss" scoped>
.custom-welcome-landing {
  width: 100%;
  height: 100vh;
  padding: 15px;
  margin: auto;
  background: none;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.7;
}
.logo {
  height: 48px;
  width: auto;
}
.custom-welcome-background {
  width: 100%;
  height: 100vh;
  padding: 15px;
  margin: auto;
  background: none;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-welcome {
  background-color: rgb(240, 240, 240);
  // background-color: rgba(255,255,255,0.5);
  color: black;
  border-radius: 5px;
  width: 800px;
  padding: 10px;
  margin: 0 auto;
  margin-top: 25px;
  border: 1px solid rgb(104, 104, 104);
}
.custom-intro {
  font-size: 1.1em;
  font-weight: 500;
  width: 90%;
  text-align: center;
  margin: auto;
}
.custom-footer {
  width: 100%;
  padding: 15px;
  position: absolute;
  bottom: 0;
  // background-color: rgba(255,255,255,0.5);
}
.custom-version {
  text-align: right;
}
</style>
